import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class RolesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      base: 0,
      aso: 0,
      master: 0,
      cvo: 0,
      crew: 0,
      crew_type: null,
      mechanic: 0,
      management: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleToggleTypeChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change['master'] = 0;
    change['cvo'] = 0;
    change['crew'] = 0;
    change['mechanic'] = 0;
    change['management'] = 0;
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    //
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      base: this.state.base,
      master: this.state.master,
      cvo: this.state.cvo,
      crew: this.state.crew,
      crew_type: this.state.crew_type,
      mechanic: this.state.mechanic,
      aso: this.state.aso,
      management: this.state.management,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cargo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/cargo/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Cargos.AdicionarCargo.titulo}</h3>
      <Link to="/cargos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Cargos.AdicionarCargo.formulario.placeholder.Nome} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.Funcao}:</label>
              <Select
                className="form-field-name"
                name="crew_type"
                value={this.state.crew_type}
                searchable={true}
                placeholder={this.locale.Cargos.AdicionarCargo.formulario.placeholder.TipoFuncao}
                onChange={this.handleSelectChange.bind(this, 'crew_type')}
                options={[
                  {value: 'Captain', label: this.locale.Cargos.AdicionarCargo.formulario.opcoesFuncao.Comandante},
                  {value: 'Copilot', label: this.locale.Cargos.AdicionarCargo.formulario.opcoesFuncao.Copiloto},
                  {value: 'Atendant', label: this.locale.Cargos.AdicionarCargo.formulario.opcoesFuncao.Comissario},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.ObrigatorioASO}?</label>
              <br/>
              <Toggle
                checked={this.state.aso}
                aria-label='No label tag'
                name="aso"
                onChange={this.handleToggleChange.bind(this, 'aso')} />
            </div>
          </div>
        </div>
        <hr/>
        <h4>{this.locale.Cargos.AdicionarCargo.formulario.tituloTiposDeCargo}</h4>
        <hr/>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.Tripulantes}</label>
              <br/>
              <Toggle
                checked={this.state.crew}
                aria-label='No label tag'
                name="crew"
                onChange={this.handleToggleTypeChange.bind(this, 'crew')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.CVODVO}</label>
              <br/>
              <Toggle
                checked={this.state.cvo}
                aria-label='No label tag'
                name="cvo"
                onChange={this.handleToggleTypeChange.bind(this, 'cvo')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.MestreDeCarga}</label>
              <br/>
              <Toggle
                checked={this.state.master}
                aria-label='No label tag'
                name="master"
                onChange={this.handleToggleTypeChange.bind(this, 'master')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.Mecanico}</label>
              <br/>
              <Toggle
                checked={this.state.mechanic}
                aria-label='No label tag'
                name="mechanic"
                onChange={this.handleToggleTypeChange.bind(this, 'mechanic')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.AdicionarCargo.formulario.Administrativo}</label>
              <br/>
              <Toggle
                checked={this.state.management}
                aria-label='No label tag'
                name="management"
                onChange={this.handleToggleTypeChange.bind(this, 'management')} />
            </div>
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Cargos.AdicionarCargo.formulario.botaoAdicionarCargo}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default RolesAdd;



// WEBPACK FOOTER //
// ./src/Components/Roles/RolesAdd.js